var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading flexCC font20"},[_c('i',{staticClass:"iconfont icon-loading"}),_c('p',{staticClass:"text-white"},[_vm._v("请稍候，资源加载中...")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }